<p-dialog class="minWidth80" [(visible)]="display" [responsive]="true" [modal]="true" (onHide)="onHide()">
	<p-header>
	  <h2 *ngIf="wizardTitleKey">{{wizardTitleKey | hisUi}}</h2>
	</p-header>
	<p-steps #steps class="wizardSteps centeringContainer" [model]="menuItems" [activeIndex]="activeIndex"></p-steps>
	<ng-container *ngIf="activeIndex === 0">
    	<res-publication-creator-wizard-name [creator]="creator" (creatorChange)="creatorChanged($event)"  (creatorChangeConfirm)=creatorChangeConfirmed($event)></res-publication-creator-wizard-name>
    </ng-container>
    <ng-container *ngIf="activeIndex === 1">
    	<res-publication-creator-wizard-person [creator]="creator" (selectionSubmit)="getNextStep(true)"></res-publication-creator-wizard-person>
    </ng-container>
    <ng-container *ngIf="activeIndex === 2">
    	<res-publication-creator-wizard-organization [creator]="creator"></res-publication-creator-wizard-organization>
    </ng-container>
    <p-footer>
		<button *ngIf="activeIndex === 0" (click)="hideDialog()">{{'common.cancel'|hisUi}}</button>
		<button *ngIf="activeIndex === 0" (click)="confirmNext()">
			<span>{{'common.next'|hisUi}}</span>
		</button>
		<button *ngIf="activeIndex === 0 && (!isNewCreator() && unchanged)" (click)="getLastStep()">
			<span>{{'fs.res.publication.creators.wizard.nextWithoutNameChange' | hisUi}}</span>
		</button>
		<button *ngIf="activeIndex !== 0" (click)="getNextStep(false)">
			<span>{{'common.back'|hisUi}}</span>
		</button>
		<button *ngIf="activeIndex === 2" (click)="saveCreator()">
			<span>{{'common.apply'|hisUi}}</span>
		</button>
	</p-footer>
</p-dialog>
